import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import FastAvatar from '../../image/FastAvatar'

interface AvatarCellProps {
  /** Image URL (profile_picture, logo, etc.) */
  image?: string | null
  /** Display name (used for Avatar fallback initials and alt text) */
  name: string
  /** Optional second line (position, email, etc.) — triggers 32px variant */
  subtitle?: string
  /** Show name initials instead of generic avatar icon when no image */
  showInitials?: boolean
}

/**
 * Shared avatar + name cell for all tables.
 * - 1-line (no subtitle): 24px avatar
 * - 2-line (with subtitle): 32px avatar
 */
const AvatarCell: React.FC<AvatarCellProps> = ({ image, name, subtitle, showInitials }) => {
  const size = subtitle ? 32 : 24
  const truncateStyle: React.CSSProperties = {
    display: 'block',
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordBreak: 'keep-all',
    overflowWrap: 'normal',
  }

  return (
    <Flex className="avatar-cell" alignItems="center" gap="8px" minW={0} w="100%" maxW="100%" overflow="hidden">
      <FastAvatar
        src={image || undefined}
        name={showInitials ? name : ''}
        boxSize={`${size}px`}
        flexShrink={0}
      />
      <Box
        className="avatar-cell-text"
        minW={0}
        w={`calc(100% - ${size + 8}px)`}
        maxW={`calc(100% - ${size + 8}px)`}
        flex="0 1 auto"
        overflow="hidden"
      >
        <Text className="mobile-truncate" textStyle="l-xs" style={truncateStyle} title={name}>
          {name}
        </Text>
        {subtitle && (
          <Text className="mobile-truncate" textStyle="b-xs" color="solid.500" mt="2px" style={truncateStyle} title={subtitle}>
            {subtitle}
          </Text>
        )}
      </Box>
    </Flex>
  )
}

export default AvatarCell
